(function($, undefined) {
	
	'use strict';
	const INTERVAL_CHARACTER_COUNT = 12;
	var utils;
	var XMLUtils;
	var imageChoiceDraggableItems;
	var imageChoicesDroppableContainer;
	var imageSortedDraggableItems;
	var imageSorterListItems;
	var lastTextareaContentLength = 0;
	var bodyScrollTop;
	var isTouchDevice;

	var randomizeImages = function() {
		var randomizedImagesArray = [];
		var imagesArray = $('.image-choice-item-ctn').map(function(i, el) {
			return $(el).find('.image').attr('src');
		}).toArray();
		
		while (imagesArray.length > 0) {
			var randomIndex = getRandomInt(0, imagesArray.length);
			var removedItem = imagesArray.splice(randomIndex, 1);
			randomizedImagesArray.push(removedItem[0]);	
		};
		
		$('.image-choice-item-ctn').each(function(i, el) {
			$(el).find('.image').attr('src', randomizedImagesArray[i]);
			$(el).removeClass('hide');
		});
		
		$('.image-choices-ctn').removeClass('processing');
	};
	
	var getRandomInt = function(min, max) {
		min = Math.ceil(min);
		max = Math.floor(max);
		return Math.floor(Math.random() * (max - min)) + min;	
	};
	
	var onImageReceiverDropped = function(event, ui) {
		var receiver = $(event.target);
		var droppedImage = $(ui.draggable).first();
		var droppedImageCtn = droppedImage.closest('.image-choice-item-ctn');
		var receiverImage = receiver.find('.image');
		
		if (!receiverImage.is(droppedImage) && receiverImage.attr('src').length === 0) {
			receiverImage.attr('src', droppedImage.attr('src'));
			receiverImage.removeClass('hide');
			receiverImage.attr('data-index', droppedImage.attr('data-index'));
			
			if (droppedImage.hasClass('choice')) {
				droppedImage.addClass('placed');
				droppedImageCtn.addClass('disabled');
				detectAllImagesPlaced();
			}
			else if (droppedImage.hasClass('sorted')) {
				droppedImage.attr('src', '');
				droppedImage.addClass('hide');
				droppedImage.removeAttr('data-index');
			}
			
			//$('.exercise-detail-ctn').trigger('exercise-state-change');
		} 
		else {
			if (!receiverImage.is(droppedImage)) {
				var receiverDataIndex = receiverImage.attr('data-index');
				var receiverSrc = receiverImage.attr('src');
				receiverImage.attr('data-index', droppedImage.attr('data-index'));
				receiverImage.attr('src', droppedImage.attr('src'));
				
				if (droppedImage.hasClass("choice")) {
					var otherImage = $('.image-choices-ctn .image.choice[data-index=' + receiverDataIndex + ']');
					var otherImageCtn = otherImage.closest('.image-choice-item-ctn');
					otherImage.removeClass('placed');
					otherImageCtn.removeClass('disabled');
					
					droppedImage.addClass('placed');
					droppedImageCtn.addClass('disabled');
				} 
				else {
					droppedImage.attr('data-index', receiverDataIndex);
					droppedImage.attr('src', receiverSrc);
				}
			}
		}	
	};
	
	var onImageChoicesDropped = function(event, ui) {
		var receiver = $(event.target);
		var droppedImage = $(ui.draggable).first();
		var droppedImageIndex = parseInt(droppedImage.attr('data-index'));
		var droppedImageContainer = receiver.find('.image-choice-item-ctn').eq(droppedImageIndex - 1);
		
		droppedImageContainer.find('.image').removeClass('placed');
		droppedImageContainer.removeClass('disabled');
		droppedImage.attr('src', '');
		droppedImage.addClass('hide');
		droppedImage.removeAttr('data-index');
		//$('.exercise-detail-ctn').trigger('exercise-state-change');
		detectAllImagesPlaced();
	};
	
	var detectAllImagesPlaced = function() {
		var ctn = $('.image-choices-ctn');
		var placedImages = ctn.find('.image.choice.placed');
		var choiceImages = ctn.find('.image-choice-item-ctn');
		
		if (placedImages.length === choiceImages.length) {
			$('.images-sorter-ctn').trigger('allImagesPlaced');
		} else {
			$('.images-sorter-ctn').trigger('imagesLeftToPlace');
		}
	};
	
	var onAllImagesPlaced = function() {
		$('.images-answer-list-ctn').find('.validate-image-sorter-btn').attr('disabled', false);
	};
	
	var onImagesLeftToPlace = function() {
		$('.images-answer-list-ctn').find('.validate-image-sorter-btn').attr('disabled', true);
	};
	
	var validateImagesSorterList = function() {
		getImagesListAnswer(function(list) {
			var currentList = $('.image-sorter-list-item').map(function() {
				return $(this).find('.image').attr('src');
			}).toArray().join(',');
			
			validateImagesSorterStory(list === currentList);
		});
	};
	
	var getImagesListAnswer = function(callback) {
		utils.getGenData($('.exercise-detail-ctn.meli-melo').attr('data-id'), function(xmlString) {
			var xml = XMLUtils.stringToXML(xmlString);
			var imagesTag = xml.getElementsByTagName('Images')[0];
			
			callback(imagesTag.getAttribute('list'));
		});
	};
	
	var validateImagesSorterStory = function(isValid) {
		if (isValid) {
			showValidAnswer();
		} 
		else {
			updateUIWrongAnswer();
		}
		$('.exercise-detail-ctn').trigger('exercise-state-change');
	};
	
	var showValidAnswer = function() {
		$('.images-sorter-list-ctn').removeClass('error').addClass('success');	
		getImagesListAnswer(function(list) {
			var sortedImagesArray = list.split(',');
			for (let key in sortedImagesArray) {
				var imageSrc = sortedImagesArray[key];
				$('.image-sorter-list-item').eq(key).find('.image').attr('src', imageSrc);
			}
			$('.image-choice-item-ctn').each(function(i, el) {
				$(el).find('.image').addClass('placed');
				$(el).addClass('disabled');
			});
			$('.validate-image-sorter-btn').closest('.tooltip-element').hide();
			$('.images-answer-list-ctn .show-right-answer-btn').hide();
			$('.images-sorter-ctn').addClass('disabled');
			enableScroll();
		});
	};
	
	var updateUIWrongAnswer = function() {
		var triesLeft = parseInt($('.images-sorter-list-ctn .exercise-tries-left .num').first().text());
		var newTriesLeft = triesLeft - 1;
		
		$('.images-sorter-list-ctn').addClass('error');
		if (newTriesLeft > 0) {
			$('.images-answer-list-ctn .reset-btn').show();
			$('.images-answer-list-ctn .validate-image-sorter-btn').hide();
			$('.images-sorter-list-ctn .exercise-tries-left .num').text(newTriesLeft);
		} else {
			$('.images-answer-list-ctn .show-right-answer-btn').show();
			$('.validate-image-sorter-btn').closest('.tooltip-element').hide();
		}
		
		if (newTriesLeft <= 0) {
			$('.images-sorter-list-ctn .exercise-tries-left .tries-text').text($('.images-sorter-list-ctn .exercise-tries-left .normal-text').attr('data-zero-tries-left-text'));
		}
	};
	
	var resetImagesSorter = function() {
		$('.images-sorter-list-ctn').removeClass('success error');
		$('.image-sorter-list-item').each(function(i, el) {
			$(el).find('.image').attr('src', '');
			$(el).find('.image').addClass('hide');
		});
		$('.image-choice-item-ctn').each(function(i, el) {
			$(el).find('.image').removeClass('placed');
			$(el).removeClass('disabled');
		});
		$('.images-answer-list-ctn .validate-image-sorter-btn').show();
		$('.images-answer-list-ctn .reset-btn').hide();
	};
	

	var onTellStoryTextareaInput = function() {
		var textarea = $(this);
		var val = textarea.val();
		var words = val.split(' ');
		// save every 50 characters or if content was pasted in (the content length changes of more than 1)
		if (val.length === 3 || (val.length > 0 && val.length % INTERVAL_CHARACTER_COUNT === 0) || Math.abs(val.length - lastTextareaContentLength) > 1) {
			$('.exercise-detail-ctn').trigger('exercise-state-change');
		}
		lastTextareaContentLength = val.length;
	};
	
	
	// https://stackoverflow.com/questions/5186441/javascript-drag-and-drop-for-touch-devices
	function touchHandler(event) {
	    var touch = event.changedTouches[0];

	    var simulatedEvent = document.createEvent("MouseEvent");
	        simulatedEvent.initMouseEvent({
	        touchstart: "mousedown",
	        touchmove: "mousemove",
	        touchend: "mouseup"
	    }[event.type], true, true, window, 1,
	        touch.screenX, touch.screenY,
	        touch.clientX, touch.clientY, false,
	        false, false, false, 0, null);

	    touch.target.dispatchEvent(simulatedEvent);
	    //event.preventDefault();
	}
	
	var initTouchActivity = function() {
		$('.images-sorter-ctn').addClass('touch-device');	
	};
	
	var onActivityTouchDevicePlayClick = function() {
		$(this).closest('.images-sorter-ctn').addClass('active');
		disableScroll();
	};
	
	var onActivityTouchDeviceDoneClick = function() {
		$(this).closest('.images-sorter-ctn').removeClass('active');	
		enableScroll();
	};
	
	var preventDefault = function(e) {
		e.preventDefault();
	};
	
	var disableScroll = function() {
		document.addEventListener("touchmove", preventDefault, {passive: false});
		bodyScrollTop = $("body").scrollTop();
		$("body").scrollTop(0);
	};
	var enableScroll = function() {
		document.removeEventListener("touchmove", preventDefault, {passive: false});
		document.addEventListener("touchmove", touchHandler, true);
		$("body").scrollTop(bodyScrollTop);
	};
	
	var initDraggableDroppable = function() {
		imageChoiceDraggableItems.draggable({
			containment: isTouchDevice ? ".images-sorter-ctn" : ".exercise-detail-ctn",
			opacity: 0.7,
			revert: true,
			revertDuration: 300,
			zIndex: 4,
			cancel: ".placed",
			start: function(event, ui) {
				ui.helper.closest('.image-choice-item-ctn').addClass('no-transform');	
			},
			stop: function(event, ui) {
				ui.helper.closest('.image-choice-item-ctn').removeClass('no-transform');
			}
		});
		imageSortedDraggableItems.draggable({
			containment: ".images-sorter-ctn",
			opacity: 1,
			revert: true,
			revertDuration: 300,
			cancel: ".hide"
		});
		imageSorterListItems.droppable({
			accept: ".image",
			hoverClass: "drop-active",
			tolerance: "pointer",
			drop: onImageReceiverDropped
		});
		imageChoicesDroppableContainer.droppable({
			accept: ".image.sorted",
			hoverClass: "drop-active",
			tolerance: "pointer",
			drop: onImageChoicesDropped
		});
	};
	
	var init = function () {
		utils = Fw.component.models().utils;
		XMLUtils = Fw.component.models().XMLUtils;
		imageChoiceDraggableItems = $('.image.draggable');
		imageChoicesDroppableContainer = $('.image-choices-ctn');
		imageSortedDraggableItems = $('.image-sorter-image-ctn .image');
		imageSorterListItems = $('.image-sorter-image-ctn.receiver');
		bodyScrollTop = $("body").scrollTop();
		isTouchDevice = utils.isTouchDevice();
		randomizeImages();
		
		document.addEventListener("touchstart", touchHandler, true);
	    document.addEventListener("touchmove", touchHandler, true);
	    document.addEventListener("touchend", touchHandler, true);
	    document.addEventListener("touchcancel", touchHandler, true);
		
		initDraggableDroppable();
		
		/*customDrag('.image.draggable', '.image-sorter-image-ctn.receiver', {
            returnOnSpill: true,
            keepPlaceholder: true,
            start: function(e) {
                console.log(e);
            },
            stop: function(e) {
                console.log(e);
            }
        });*/
		
		$('.images-sorter-ctn').on('allImagesPlaced', onAllImagesPlaced);
		$('.images-sorter-ctn').on('imagesLeftToPlace', onImagesLeftToPlace);
		$('.validate-image-sorter-btn').on('click', validateImagesSorterList);
		$('.images-answer-list-ctn .reset-btn').on('click', resetImagesSorter);
		$('.images-answer-list-ctn .show-right-answer-btn').on('click', showValidAnswer);
		
		$('.tell-story-textarea').on('input', onTellStoryTextareaInput);
		
		if (isTouchDevice) {
			initTouchActivity();
		}
		$('.touch-device-play-btn').on('click', onActivityTouchDevicePlayClick);
		$('.touch-device-done-btn').on('click', onActivityTouchDeviceDoneClick);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
